import React from 'react';
import { Route, Switch, matchPath, useLocation } from 'react-router-dom';
import ButtonToolbar from 'components/button-toolbar';
import PasswordReset from 'components/password-reset';
import Q4E from 'components/q4e';
import { UserDetails, UserCreditCards } from 'components/user-profile';
import { ProfileTabs } from 'constants/user-form';
import styles from '../styles/UserTabs.module.scss';
import { IUser } from 'types';
import {
  PROFILE_CREDIT_CARD_ROUTE,
  PROFILE_ROUTE,
  PROFILE_SHARE_ROUTE,
  WORKPLACE_ROUTE,
} from 'constants/routes';
import history from 'helpers/history';
import ShareContainer from '../../share/ShareContainer';

const tabs = [
  { name: ProfileTabs.DETAILS, exact: true, path: PROFILE_ROUTE },
  { name: ProfileTabs.WORKPLACE, path: WORKPLACE_ROUTE },
  {
    name: ProfileTabs.CREDIT_CARDS,
    path: PROFILE_CREDIT_CARD_ROUTE,
  },
  {
    name: ProfileTabs.SHARED,
    path: PROFILE_SHARE_ROUTE,
  },
];

const getActiveTab = (tabs, location) => {
  const match = tabs.find((t) => matchPath(t.path, location.pathname));
  return match?.name || 'Profile';
};
interface IUserTabsProps {
  user: IUser;
}

const UserTabs = ({ user }: IUserTabsProps) => {
  const location = useLocation();

  const isAuth0User = user.id && user.id.indexOf('auth0') > 0;
  const active = getActiveTab(tabs, location);
  const handleArrowClick = (item) => history.push(item.path);

  return (
    <>
      <ButtonToolbar
        items={tabs}
        active={active}
        onNextClick={handleArrowClick}
        onPrevClick={handleArrowClick}
        className={styles.tabs}
        itemClassName={styles.tab}
        responsive={true}
      />
      <div className={styles.content}>
        <Switch>
          <Route path={PROFILE_CREDIT_CARD_ROUTE}>
            <UserCreditCards />
          </Route>
          <Route path={WORKPLACE_ROUTE}>
            <Q4E />
          </Route>
          <Route path={PROFILE_SHARE_ROUTE}>
            <ShareContainer />
          </Route>
          <Route path={PROFILE_ROUTE}>
            <UserDetails />
          </Route>
        </Switch>
      </div>
      <div className={styles.buttons}>
        {isAuth0User && (
          <PasswordReset className={styles.reset} email={user.email} />
        )}
      </div>
    </>
  );
};

export default UserTabs;
